import PicturesApp from 'station/components/picture/PicturesApp'
import React from 'react'
import { shallowEqual, useSelector } from 'react-redux'
import useTitle from 'utils/customHook/useTitle'
import i18n from 'simple-react-i18n'
import { getStationTitle } from 'utils/StationUtils'

const InstallationPicturesApp = ({

}) => {
    const {
        installation,
        installations,
    } = useSelector(store => ({
        installation: store.InstallationReducer.installation,
        installations: store.InstallationReducer.installationsLight,
    }), shallowEqual)

    useTitle(() => [{
        title: i18n.installation,
        href: 'installation',
    }, {
        title: getStationTitle(installation),
        href: `station/installation/${installation?.id}`,
    }, {
        title: i18n.picturesAndDocuments,
        href: `station/installation/${installation?.id}/picture`,
    }], [installation])

    return (
        <PicturesApp
            stations={installations}
            station={installation}
            stationType='installation'
        />
    )
}

export default InstallationPicturesApp